module.exports = "/_next/static/images/tu-8d17b95189b0a84d8dbb407fada694fd.png";